import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { MessageService } from '@bioreferencehealth/ui-kit';
import { AppRouteEnum } from 'src/app/enums/app-route.enum';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/modules/analytics/services/google-analytics.service';
import { AnalyticsEventName } from 'src/modules/analytics/models/analytics-event-name.enum';
import { SUPPRESS_NOT_FOUND_TOAST } from 'src/interceptors/error/suppress-not-found-toast.token';

export const generalErrorInterceptorFn: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const messageService = inject(MessageService);
  const analyticsService = inject(GoogleAnalyticsService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const status = error.status;
      const isHandledNotFound = status === 404 && request.context.get(SUPPRESS_NOT_FOUND_TOAST);
      if ((status === 404 && !isHandledNotFound) || status >= 500 || status === 0) {
        console.error(`Error ${status}: ${error.message}`);
        messageService.error('Something went wrong');
        analyticsService.trackEvent(AnalyticsEventName.ApiErrorShown, { httpStatus: status });
      }

      if (status === 403) {
        router.navigateByUrl(AppRouteEnum.Forbidden, { skipLocationChange: true });
      }

      return throwError(() => error);
    })
  );
};
